module.exports = __webpack_public_path__ + "static/media/BD.c090fd68.wav";